import { MessageCircle, Globe, Smartphone, type LucideIcon } from "lucide-react"

export interface Platform {
  id: string
  name: string
  icon: LucideIcon
  description: string
  action: string
  link?: string
  badge?: string
  comingSoon?: boolean
}

export const platforms: Platform[] = [
  {
    id: "wechat",
    name: "微信小程序",
    icon: MessageCircle,
    description:
      "零门槛开始：不用下载，拍照录入、训练、问小智，都在微信里完成。",
    action: "微信搜索「智因错题本」",
  },
  {
    id: "web",
    name: "Web 网页版",
    icon: Globe,
    description:
      "大屏沉浸式学习：错题浏览、数据分析、深度训练与组卷。",
    action: "打开 Web 版",
    link: "https://app.zyctb.com",
  },
  {
    id: "mobile",
    name: "移动 App",
    icon: Smartphone,
    description:
      "深度用户的归宿：原生相机、离线训练、系统推送，体验最完整。",
    action: "敬请期待",
    badge: "开发中",
    comingSoon: true,
  },
]
